import Swiper from 'swiper/bundle'
const reviewsCategorySlider = document.querySelector(
  '.hero__reviews-category-slider'
)

if (reviewsCategorySlider) {
  new Swiper(reviewsCategorySlider, {
    slidesPerView: 1.3,
    spaceBetween: 15,
    grabCursor: true,
    breakpoints: {
      576: {
        slidesPerView: 2.3,
      },
      768: {
        slidesPerView: 3.2,
      },
      992: {
        slidesPerView: 4,
      },
    },
  })
}

const features = document.querySelector('.hero-features__slider')
if (features) {
  new Swiper(features, {
    slidesPerView: 1.3,
    spaceBetween: 10,
    breakpoints: {
      576: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 15,
      },
      1640: {
        slidesPerView: 4,
        spaceBetween: 55,
      },
    },
  })
}
